import moment from "moment-timezone";
import React, {Component, createElement, PropTypes} from "react";
import {Modal} from "react-bootstrap";

import {LoadingIcon} from "@ergeon/erg-components-react";

import {trackEvent} from "metrics";
import api from "v2/api";

const CLEAR_DELAY = 5000;

export default class AdjustDurationsLink extends Component {
  static contextTypes = {
    onUpdateRouteData: PropTypes.func,
    params: PropTypes.shape({
      routeId: PropTypes.string.isRequired,
    }),
  }
  static defaultProps = {
    component: "div",
  }
  static propTypes = {
    component: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string,
    ]),
  }

  state = {
    clicked: false,
    diff: null,
    error: null,
  }

  handleAdjustDurations = (evt) => {
    evt.preventDefault();
    this.setState({
      clicked: true,
    });

    const {onUpdateRouteData, params: {routeId}} = this.context;
    const clearState = () => {
      setTimeout(this.handleClearState, CLEAR_DELAY);
    };

    api()
      .post(this.apiUrl)
      .then(({data}) => {
        onUpdateRouteData(null, () => {
          trackEvent("Adjust Durations", ["Route", "adjust", routeId], {
            "Route ID": routeId,
          });
          this.setState({
            clicked: false,
            diff: moment.duration(data.diff),
          }, clearState);
        });
      }, () => {
        this.setState({
          clicked: false,
          error: true,
        }, clearState);
      });
  }

  handleClearState = (evt) => {
    evt && evt.preventDefault();
    this.setState({
      diff: null,
      error: null,
    });
  }

  get apiUrl() {
    const {params: {routeId}} = this.context;
    return `/routes/${routeId}/adjust-durations`;
  }

  renderModal() {
    const {clicked, diff, error} = this.state;
    if (!clicked && !diff && !error) {
      return null;
    }

    let content;
    if (clicked) {
      content = (
        <p className="text-muted">
          <LoadingIcon />
        </p>
      );
    } else if (diff) {
      content = (
        <p>
          Durations adjusted. Diff: <strong>{diff.asMinutes()} min</strong>
        </p>
      );
    } else if (error) {
      content = (
        <p className="text-danger">
          Cannot adjust durations due to server error. Please try again later.
        </p>
      );
    }

    return (
      <Modal key="modal" show>
        <Modal.Body>
          {content}
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-success"
            disabled={clicked}
            onClick={this.handleClearState}
            type="button">
            OK
          </button>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    const {component} = this.props;
    return createElement(component, {}, [
      <a href="#" key="link" onClick={this.handleAdjustDurations}>
        Adjust Durations
      </a>,
      this.renderModal(),
    ]);
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/AdjustDurationsLink.js
 **/